import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LeadDataObject, LeadsDataAction } from '../../../../../models/leads/leads.model';
import { Router } from '@angular/router';
import { ActionHelper } from '../../../../../helper/action.helper';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../../services/leads/leads-data.service';
import { ActionIconHelper } from '../../../../../helper/action-icon.helper';
import { IS_DUPLICATED_LEAD } from '../../../../../constants/constants';

@Component({
  selector: 'fi-table-popup-old',
  templateUrl: './table-popup-old.component.html',
  styleUrls: ['./table-popup-old.component.scss'],
  standalone: false,
})
export class TablePopupOldComponent implements OnChanges {
  @Input() lead: LeadDataObject;
  @Input() externalEmail: string;
  @Input() read: boolean;
  @Input() suggestedAction: LeadsDataAction;
  @Input() callOursContactPopup: boolean;
  @Input() isDuplicateLead: boolean;
  @Input() isRotateScreen: boolean;
  @Input() leadId: number;
  @Input() activatedDevice: boolean;
  @Input() reverseData: {rowPopUp: HTMLElement, contactLength: number, index: number};

  @Output() closeModal = new EventEmitter();
  @Output() markAsRead = new EventEmitter<number>();
  @Output() markAsUnread = new EventEmitter<number>();
  @Output() isLoaded = new EventEmitter<boolean>();
  @Output() showActions = new EventEmitter<boolean>();
  // loadedLeadComposerOffers: LeadComposerChangesModel[];
  actionHelper = ActionIconHelper;
  actions: LeadsDataAction[] = [];
  showContent = false;

  constructor(
      private dialog: MatDialog,
      private router: Router,
      @Inject(LEADS_DATA_SERVICE) private leadDataService: LeadsDataService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.leadId?.currentValue && this.activatedDevice && !this.isDuplicateLead) {
      this.leadDataService.getActionsById(this.leadId).subscribe(({ success, data }) => {
        if (success) {
          this.actions = data;

          if (!!data) {
            this.reversePositionRowPopup();
            this.showContent = true;
            this.showActions.emit(this.showContent);
          }
        }
      });
    } else if (this.isDuplicateLead) {
      this.actions = [];
      this.showContent = true;
      this.showActions.emit(this.showContent);
    }

  }

  closeOverlay(): void {
    this.closeModal.emit();
  }

  onBtnClick(action: LeadsDataAction): void {

    // this.leadDataService.getLeadComposerOffers(this.leadId).subscribe(({ success, data }) => {
    // if (success) {
    // this.loadedLeadComposerOffers = data;
    // }
    //code in bottom should be there
    // });
    const actionData = this.getData(action);
    ActionHelper.showAction(action.Name, this.dialog, actionData)?.afterClosed().subscribe(value => {
      if (value === 'remove') {
        // @ts-ignore
        this.actions.splice(this.actions.findIndex(item => item.Name === name), 1);
        ActionHelper.reloadLeadsTable(this.router);
        this.closeOverlay();
      }
    });
  }

  onDuplicateBtnClick(): void {
    const actionData = { leadId: this.lead?.Id };

    ActionHelper.showAction('DUPLICATE-CHECK', this.dialog, actionData)?.afterClosed().subscribe(value => {
      if (value === 'solved') {
        ActionHelper.reloadLeadsTable(this.router);
        this.closeOverlay();
      }
    });
  }

  emitMarkAsRead(): void {

    if (this.isDuplicateLead) {
      sessionStorage.setItem(IS_DUPLICATED_LEAD, 'true');
      this.router.navigate(['/details/' + this.lead.Id]);
      return;
    }
    sessionStorage.setItem(IS_DUPLICATED_LEAD, 'false');
    if (!this.read) {
      this.markAsRead.emit(this.lead.Id);
    } else {
      this.router.navigate(['/details/' + this.lead.Id]);
    }
  }

  emitMarkAsUnread(): void {
    if (this.read) {
      this.markAsUnread.emit(this.lead.Id);
    }
  }

  private getData(action: LeadsDataAction): any {
    return {
      title: action?.Label,
      contactName: this.lead.Contact?.FirstName + ' ' + this.lead.Contact?.LastName,
      leadId: this.lead?.Id,
      leadTypeId: this.lead?.LeadTypeId,
      externalEmail: this.externalEmail,
      // loadedLeadComposerOffers: this.loadedLeadComposerOffers
    };
  }

  reversePositionRowPopup(): void {
    if (this.reverseData?.contactLength > 3) {
      if (this.reverseData.index === this.reverseData.contactLength - 1 || this.reverseData.index === this.reverseData.contactLength - 2 || this.reverseData.index === this.reverseData.contactLength - 3) {
        const length = this.actions.length;
        const height = 111 + (length * 62);
        this.reverseData.rowPopUp.style.height = height + 'px';
        this.reverseData.rowPopUp.style.top = -height + 'px';
        this.reverseData.rowPopUp.classList.remove('normal');
        this.reverseData.rowPopUp.classList.add('reverse');
      }
    }
  }

}
